import api from '../Services/api'
import { useEffect } from "react"
import { useCart } from "react-use-cart"
import { getProductStockSummary } from '../Utilities/ProductStock'

const useUpdatedCart = () => {
    const cart = useCart()

    useEffect(() => {
        const fetchItems = async () => {
            const ids = cart.items.map(item => item.id).join(',')
            const response = await api.get(`/data/products/?id=${ids}`)
            if (response && response.data) {
                // update cart.items
                const itemsDictionary = {}
                for (let item of response.data) {
                    const { tokoStock, warehouseStock } = getProductStockSummary(item.stocks)
                    item.stock = tokoStock
                    item.tokoStock = tokoStock
                    item.warehouseStock = warehouseStock
                    
                    itemsDictionary[item.id] = item
                }
    
                for (let i = 0; i < cart.items.length; i++) {
                    const oldCartItem = cart.items[i]
                    const newCartItem = itemsDictionary[oldCartItem.id]

                    if (newCartItem && oldCartItem.quantity > newCartItem.stock) {
                        newCartItem.quantity = newCartItem.stock
                    }

                    if (newCartItem) {
                        cart.updateItem(oldCartItem.id, newCartItem)
                    }
                }
            }
        }

        fetchItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {...cart}
}

export default useUpdatedCart

